export default "__VITE_ASSET__CIfAbUWG__"